import { render, staticRenderFns } from "./ImageCaptureReceipt.vue?vue&type=template&id=98487ea2&scoped=true&"
import script from "./ImageCaptureReceipt.vue?vue&type=script&lang=js&"
export * from "./ImageCaptureReceipt.vue?vue&type=script&lang=js&"
import style0 from "./ImageCaptureReceipt.vue?vue&type=style&index=0&id=98487ea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98487ea2",
  null
  
)

export default component.exports